/* Presentation only. Shopify owns all prices, eligibility and checkout discounts.
 * Cart writes happen only after an explicit click; existing cart code is untouched.
 */
(() => {
  const configElement = document.getElementById('zk-tee-config');
  if (!configElement || window.zkTeeCampaign) return;
  const config = JSON.parse(configElement.textContent);
  if (!config.enabled) return;
  customElements.define('zk-tee-message',class extends HTMLElement {connectedCallback(){this.hidden=false;}});
  customElements.define('zk-tee-badge',class extends HTMLElement {connectedCallback(){this.hidden=false;}});
  const root = window.Shopify?.routes?.root || '/';
  const shirtIds = new Set(config.shirtIds.map(String));
  const bagIds = new Set(config.bags.map(b => String(b.id)));
  const campaignTitles = new Map([['4 T-shirts – samlet 499 kr.',4],['Bland 8 T-shirts for 998 kr.',8]]);
  const storageKey = 'zk-4for499-bag-dismissed-v1';
  let cart, timer, fetching, adding = false, shown = false, previousFocus;
  try { shown = sessionStorage.getItem(storageKey) === '1'; } catch (_) {}
  const money = cents => new Intl.NumberFormat('da-DK', { maximumFractionDigits:2 }).format(cents / 100) + ' kr.';
  const colour = title => ({Black:'Sort',Khaki:'Sand',Green:'Grøn'})[title] || title;
  const node = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };

  function state(value) {
    const items = value?.items || [];
    const shirts = items.filter(i => shirtIds.has(String(i.product_id)));
    const quantity = shirts.reduce((sum, item) => sum + item.quantity, 0);
    const tier = Math.max(0,...shirts.flatMap(i => (i.line_level_discount_allocations || []).map(a => campaignTitles.get(a.discount_application?.title) || 0)));
    const discounted = tier > 0;
    return {quantity, tier, discounted, eligible:value?.currency === 'DKK' && quantity >= tier && discounted,
      hasBag:items.some(i => bagIds.has(String(i.product_id)))};
  }

  async function request(path, body) {
    const r = await fetch(path, {credentials:'same-origin',cache:'no-store',
      method:body ? 'POST' : 'GET',headers:{Accept:'application/json',...(body ? {'Content-Type':'application/json'} : {})},
      ...(body ? {body:JSON.stringify(body)} : {})});
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || 'Kurven kunne ikke opdateres. Prøv igen.');
    return data;
  }

  const dialog = node('dialog','zk-tee-dialog');
  dialog.setAttribute('aria-labelledby','zk-tee-heading');
  const close = node('button','zk-tee-dialog__close','×');
  close.type = 'button'; close.setAttribute('aria-label','Luk tilbud');
  const eyebrow = node('p','zk-tee-dialog__eyebrow','4 T-SHIRTS FOR 499 KR. ✓');
  const heading = node('h2','','Tag en taske med for kun 299 kr.');
  heading.id = 'zk-tee-heading';
  const intro = node('p','zk-tee-dialog__intro','Du har valgt mindst 4 T-shirts. Vælg en Crosslander eller Urban til din hverdag og næste tur.');
  const cards = node('div','zk-tee-dialog__bags');
  const error = node('p','zk-tee-dialog__error'); error.setAttribute('role','alert'); error.hidden = true;
  const buttons = [];
  for (const bag of config.bags) {
    const card = node('article','zk-tee-bag');
    const img = node('img'); img.width = 240; img.height = 180;
    const title = node('h3','',bag.title.replace(' Rygsæk',''));
    const price = node('p','zk-tee-bag__price','299 kr.');
    const label = node('label','','Farve'); label.htmlFor = 'zk-tee-colour-' + bag.id;
    const select = node('select'); select.id = label.htmlFor;
    for (const variant of bag.variants) {
      const option = node('option','',colour(variant.title) + (variant.available ? '' : ' – udsolgt'));
      option.value = variant.id; option.disabled = !variant.available; select.append(option);
    }
    const available = bag.variants.find(v => v.available);
    if (available) select.value = available.id;
    const link = node('a','','Se tasken'); link.href = bag.url;
    function changeImage() {
      const variant = bag.variants.find(v => String(v.id) === select.value) || bag.variants[0];
      if (variant) {img.src = variant.image; img.alt = bag.title + ' – ' + colour(variant.title);
        link.href = bag.url + '?variant=' + variant.id;}
    }
    select.addEventListener('change',changeImage); changeImage();
    const add = node('button','','Tilføj ' + (bag.title.startsWith('Urban') ? 'Urban' : 'Crosslander'));
    add.type = 'button'; add.disabled = !available; add.dataset.available = String(!!available);
    if (!available) add.textContent = 'Udsolgt';
    add.addEventListener('click',()=> addBag(bag, select.value)); buttons.push(add);
    card.append(img,title,price,label,select,add,link);cards.append(card);
  }
  const summary = node('div','zk-tee-dialog__summary');
  summary.append(node('span','','4 T-shirts + 1 taske'),node('strong','','798 kr.'));
  const terms = node('p','zk-tee-dialog__terms','Én taske til kampagnepris pr. ordre. Kræver mindst 4 T-shirts i kurven. Pakkeprisen gælder 4 eller 8 T-shirts; ved flere får de billigste pakkepris, og resten får normalpris. Eventuelt navnemærke købes separat.');
  const decline = node('button','zk-tee-dialog__decline','Nej tak, fortsæt med mine T-shirts'); decline.type = 'button';
  dialog.append(close,eyebrow,heading,intro,cards,summary,terms,error,decline);
  document.body.append(dialog);
  function remember() { shown = true; try {sessionStorage.setItem(storageKey,'1');} catch (_) {} }
  function dismiss() { remember();dialog.close(); }
  close.addEventListener('click',dismiss); decline.addEventListener('click',dismiss);
  dialog.addEventListener('cancel',remember);
  dialog.addEventListener('close',()=> { if(previousFocus?.isConnected) previousFocus.focus(); });
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dismiss();}});

  function open() {
    const s = state(cart);
    if (!s.eligible || s.hasBag || adding || dialog.open) return;
    eyebrow.textContent = `${s.tier} T-SHIRTS FOR ${s.tier === 8 ? '998' : '499'} KR. ✓`;
    summary.replaceChildren(node('span','',`${s.tier} T-shirts + 1 taske`),node('strong','',money((s.tier === 8 ? 99800 : 49900) + 29900)));
    previousFocus = document.activeElement; error.hidden = true;
    dialog.showModal(); remember(); close.focus();
  }

  function render(value, allowPopup = true) {
    cart = value;
    const s = state(cart);
    if ((!s.eligible || s.hasBag) && dialog.open) dialog.close();
    document.querySelectorAll('zk-tee-cart-state').forEach(slot => {
      slot.hidden = !s.quantity || value.currency !== 'DKK';
      slot.className = 'zk-tee-progress'; slot.replaceChildren();
      if (slot.hidden) return;
      const title = s.eligible ? `${s.tier} T-shirts · ${money(s.tier === 8 ? 99800 : 49900)}` : 'Bland 4 T-shirts for 499 kr.';
      slot.append(node('strong','',title));
      if (s.quantity < 4) {
        const missing = 4 - s.quantity;
        slot.append(node('p','',`Du har valgt ${s.quantity} af 4. Vælg ${missing} mere for at få pakkeprisen.`));
        const track = node('div','zk-tee-progress__track'); track.setAttribute('aria-hidden','true');
        for(let i=0;i<4;i++){const dot=node('i');if(i<s.quantity)dot.dataset.filled='';track.append(dot);}slot.append(track);
        const link=node('a','','Find dine næste T-shirts →');link.href=root+'collections/t-shirts';slot.append(link);
      } else if (!s.discounted) {
        slot.append(node('p','','Kampagneprisen er ikke bekræftet i kurven. Kontrollér kurvens pris før betaling.'));
      } else {
        slot.append(node('p','',s.hasBag ? 'Din taske er i kurven. Se den beregnede pris ved varen.' : 'Du kan også vælge én Crosslander eller Urban for kun 299 kr.'));
        if(!s.hasBag){const more=node('button','','Vælg taske til 299 kr. →');more.type='button';more.addEventListener('click',open);slot.append(more);}
        const extras = s.quantity - s.tier;
        if(extras) slot.append(node('p','',`${extras} ekstra T-shirt${extras>1?'s':''} afregnes til almindelig pris. De ${s.tier} billigste får pakkeprisen.`));
      }
    });
    if (allowPopup && s.eligible && !s.hasBag && !shown) open();
  }

  async function refresh() {
    if (fetching) return fetching;
    fetching = request(root+'cart.js').then(c=>render(c)).catch(()=>{if(dialog.open)dialog.close();}).finally(()=>{fetching=null;});
    return fetching;
  }
  function scheduleRefresh() {clearTimeout(timer);timer=setTimeout(refresh,200);}

  async function refreshCart(cart, controller) {
    if (!controller?.getSectionsToRender || !controller?.renderContentsAndDependencies) {
      window.location.assign(root+'cart');return;
    }
    const sections = controller.onCartPage ? [...new Set(controller.getSectionsToRender()
      .filter(s=>document.getElementById(s.id)||(s.bubble&&document.querySelector(s.selector))).map(s=>s.section).filter(Boolean))]
      : ['header-cart','cart-icon-bubble'];
    const rendered={};
    for(let start=0;start<sections.length;start+=5){
      const url=new URL(controller.onCartPage?window.location.href:root,window.location.origin);
      url.searchParams.set('sections',sections.slice(start,start+5).join(','));
      const result=await request(url.toString());
      if(Object.values(result).some(v=>v===null))throw new Error('Genindlæs kurven.');
      Object.assign(rendered,result);
    }
    const result={...cart,sections:rendered};
    if(controller.onCartPage){controller.renderContentsAndDependencies(result);return;}
    const parser=new DOMParser();
    const doc=parser.parseFromString(rendered['header-cart'],'text/html');
    if(!doc.querySelector('.js-contents-cart-items'))throw new Error('Genindlæs kurven.');
    for(const selector of ['.js-contents-cart-items','.js-contents-subtotal','.js-contents-buttons','.js-contents-free-shipping']){
      const source=doc.querySelector(selector),target=controller.querySelector(selector);if(source&&target)target.innerHTML=source.innerHTML;
    }
    const counter=parser.parseFromString(rendered['cart-icon-bubble'],'text/html').querySelector('.header-cart-count');
    if(counter)document.querySelectorAll('.header-cart-count').forEach(el=>{el.innerHTML=counter.innerHTML;});
    controller.toggleEmptyClass(result);controller.currentLineCount=controller.querySelectorAll('[name="updates[]"]').length;
    controller.currentItemCount=cart.item_count;controller.setParsedState(result);controller.setCartJs();
    document.querySelector('shipping-calculator')?.setUpdateStatus('true');
    if(typeof Scrollbar!=='undefined')controller.querySelectorAll('[data-scrollbar]').forEach(el=>Scrollbar.get(el)?.update());
  }

  async function addBag(bag, variantId) {
    const selected=bag.variants.find(v=>String(v.id)===String(variantId));
    if(adding||!selected?.available)return;
    adding=true;buttons.forEach(b=>{b.disabled=true;});error.hidden=true;dialog.setAttribute('aria-busy','true');
    const controller=Array.from(document.querySelectorAll('cart-items')).find(el=>el.getBoundingClientRect().width>0);
    let attempted=false, confirmed=false;
    try {
      const before=await request(root+'cart.js');
      const s=state(before);
      if(!s.eligible||s.hasBag){render(before,false);return;}
      attempted=true;
      try {await request(root+'cart/add.js',{items:[{id:selected.id,quantity:1}]});confirmed=true;}
      catch(e){
        // Check ambiguous outcomes once. Never retry the write automatically.
        const current=await request(root+'cart.js');
        if(!current.items.some(i=>String(i.variant_id||i.id)===String(selected.id))){attempted=false;throw e;}
        confirmed=true;
      }
      const after=await request(root+'cart.js');
      render(after,false);dialog.close();
      await refreshCart(after,controller);
    } catch(e) {
      if(attempted||confirmed){window.location.assign(root+'cart');return;}
      error.textContent=e.message||'Tasken kunne ikke tilføjes. Prøv igen.';error.hidden=false;
    } finally {
      adding=false;buttons.forEach(b=>{b.disabled=b.dataset.available!=='true';});dialog.removeAttribute('aria-busy');
    }
  }

  customElements.define('zk-tee-cart-state',class extends HTMLElement {connectedCallback(){scheduleRefresh();}});
  window.addEventListener('pageshow',scheduleRefresh);
  document.addEventListener('cart:updated',scheduleRefresh);
  document.addEventListener('ajaxProduct:added',scheduleRefresh);
  window.addEventListener('storage',e=>{if(e.key==='cartJs')scheduleRefresh();});
  window.zkTeeCampaign={refresh};
  scheduleRefresh();
})();
